/**
 * @name: index.jsx
 * @user: cfj
 * @date: 2022/4/22
 * @description: 作废统计明细
 */
import React, { useState, useRef } from 'react';
import { Table } from '@components/table'
import { Space, message, Tag } from 'antd';
import { getDiscardLog, sessionAPI, taskFlowAPI } from '@api'
import { Button, LazyLoadingImage, TaskDrawer } from '@components'
import PreviewImage from '@components/image/preview_image'
import { FilterForm } from '@views/4_stats/destroy/filterForm'
import ConfirmRedoModal from '@views/4_stats/destroy/ConfirmRedoModal'
import moment from 'moment'
import { useHistory } from 'react-router'
import { setRemakeMmark } from '@api'
import { $success, $error } from "@/components";


export function momentArrDataToTimes(datas, key, unitOfTime = 'day') {
    if (datas && Array.isArray(datas)) {
        const times = {}
        const [start, end] = datas
        times[`${key}_start`] = moment(start)
            .startOf(unitOfTime)
            .format('YYYY-MM-DD HH:mm:ss')
        times[`${key}_end`] = moment(end)
            .endOf(unitOfTime)
            .format('YYYY-MM-DD HH:mm:ss')
        return times
    }
    return undefined
}

function request(page, pageSize, params) {
    const {
        create_time,
        discard_time,
        _refresh,
        ...other
    } = params || {}
    const _value = getDiscardLog({
        page,
        page_size: pageSize,
        ...momentArrDataToTimes(create_time, 'create_time'),
        ...momentArrDataToTimes(discard_time, 'discard_time'),
        ...other
    })
    return _value;
}

const DestroyStatisticsDetails = function () {
    const history = useHistory()
    const [redoModalVisible, setRedoModalVisible] = useState(false)
    const [redoRecord, setRedoRecord] = useState(null)
    const [tableRefreshKey, setTableRefreshKey] = useState(0)
    const tableRef = useRef(null)
    const filterFormRef = useRef(null)

    const openRedoConfirm = (record) => {
        setRedoRecord(record)
        setRedoModalVisible(true)
    }

    const closeRedoConfirm = () => {
        setRedoModalVisible(false)
        setRedoRecord(null)
    }

    const handleRedoConfirm = async () => {
        if (!redoRecord?.task_id) return
        try {
            setRemakeMmark({
                id: redoRecord.task_id,
                remake_mark: true
            }).then((res) => {
                setRedoModalVisible(false)
                setRedoRecord(null)
                $success('操作成功')
                setTableRefreshKey((k) => k + 1)
                setTimeout(() => filterFormRef.current?.submit?.(), 0)
            }).catch((err) => {
                setRedoModalVisible(false)
                setTimeout(() => filterFormRef.current?.submit?.(), 0)
            });
        } catch (e) {
            $error(e?.message)
        }
    }

    const columns = [
        {
            title: '预览图',
            dataIndex: 'review_image',
            render(text, record) {
                const src = record.review_image
                const onPreview = function (src) {
                    PreviewImage.open({
                        images: [src],
                        request: (url) => sessionAPI.fetchOriginalImage(url)
                            .then(res => res.data?.origin_urls?.[0] || '')
                    })
                }
                return <LazyLoadingImage
                    preview={{
                        visible: false
                    }}
                    onClick={(event) => {
                        event.stopPropagation()
                        onPreview(src)
                    }}
                    width='60px'
                    height='60px'
                    src={src} />
            }
        },
        {
            title: '资产ID',
            dataIndex: 'asset_uid'
        },
        {
            title: '资产名称',
            dataIndex: 'asset_name'

        },
        {
            title: '创建时间',
            dataIndex: 'create_time'
        },
        {
            title: '作废人',
            dataIndex: 'operator_name'
        },
        {
            title: '作废类型',
            dataIndex: 'discard_type'
        },
        {
            title: '作废时间',
            dataIndex: 'discard_time'
        },
        {
            title: '项目来源',
            ellipsis: {
                showTitle: true
            },
            dataIndex: 'project_name'
        },
        {
            title: '标记重做',
            render(text, record) {
                return (
                    <Tag color={Number(record.remake_mark) === 1 ? 'red' : ''}>{Number(record.remake_mark) === 1 ? '重做' : ''}</Tag>
                )
            }
        },
        {
            title: '备注',
            dataIndex: 'comment',
            ellipsis: true
        },
        {
            title: '操作',
            render(text, record) {
                return (
                    <Space>
                        <Button type={'link'} onClick={() => {
                            history.push(`/stats/destroy/details?task_flow?taskId=${record.task_id}`)
                        }}>
                            查看
                        </Button>
                        {
                          Number(record?.remake_mark) !==1 && (
                            <Button
                                size={'small'}
                                type={'link'}
                                onClick={() => openRedoConfirm(record)}
                            >
                                标记重做
                            </Button>
                          )
                        }
                    </Space>
                );
            }
        }
    ]
    return <div className={'page-container'} style={{
        position: 'relative',
        height: 'calc(100VH - 66px)',
        overflow: 'hidden',
    }}>
        <div style={{ height: '100%', overflow: 'auto' }}>
            <Table
                ref={tableRef}
                filterFormRef={filterFormRef}
                params={{ _refresh: tableRefreshKey, remake_mark: -1 }}
                renderFilterForm={(props) => <FilterForm {...props} ref={props.filterFormRef} />}
                url={'/api/task-statistic/discard-log'}
                request={request}
                columns={columns}
            />
        </div>
        <TaskDrawer />
        <ConfirmRedoModal
            visible={redoModalVisible}
            onCancel={closeRedoConfirm}
            onConfirm={handleRedoConfirm}
            content="是否确认标记为重做状态"
        />
    </div>

}
export default DestroyStatisticsDetails
